var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.$ceres.isSSR,
          expression: "!$ceres.isSSR"
        }
      ],
      staticClass: "cookie-bar",
      class: {
        out: !_vm.isVisible,
        "border-top bg-white": _vm.isVisible,
        "fixed-bottom": !_vm.isShopBuilder || false
      }
    },
    [
      _vm.isVisible
        ? _c("div", { staticClass: "container-max" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isExpanded,
                    expression: "!isExpanded"
                  }
                ],
                staticClass: "row py-3",
                class: _vm.classes,
                style: _vm.styles
              },
              [
                _c("div", { staticClass: "col-12 col-md-8" }, [
                  _c("div", { staticClass: "h3 font-weight-bold" }, [
                    _vm._v(
                      "\n                  " +
                        _vm._s(
                          _vm.$translate("Phywe::Template.cookieHeadline")
                        ) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { domProps: { innerHTML: _vm._s(_vm.text) } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm._l(_vm.consentGroups, function(consentGroup) {
                        return [
                          consentGroup.consents.length > 0
                            ? _c(
                                "span",
                                {
                                  key: consentGroup.key,
                                  staticClass:
                                    "custom-control custom-switch custom-control-appearance d-md-inline-block mr-3"
                                },
                                [
                                  _c("input", {
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "checkbox",
                                      id:
                                        _vm._cid + "-group-" + consentGroup.key,
                                      disabled: consentGroup.necessary
                                    },
                                    domProps: {
                                      checked:
                                        _vm.isConsented(consentGroup.key) ||
                                        consentGroup.necessary
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.toggleConsent(
                                          consentGroup.key
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: {
                                        for:
                                          _vm._cid +
                                          "-group-" +
                                          consentGroup.key
                                      }
                                    },
                                    [
                                      consentGroup.label.length > 0
                                        ? [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(consentGroup.label) +
                                                "\n                                "
                                            )
                                          ]
                                        : [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.privacySettingsDefaultGroup"
                                                  )
                                                ) +
                                                "\n                                "
                                            )
                                          ]
                                    ],
                                    2
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "text-primary text-appearance d-block d-md-inline-block",
                          attrs: {
                            href: "#",
                            "data-testing": "cookie-bar-show-more-information"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.isExpanded = true
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.cookieBarMoreSettings"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "button-order col-12 col-md-4 pt-3 pt-md-0" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-block btn-default btn-appearance button-order-1 mb-2 mt-0",
                        attrs: { "data-testing": "cookie-bar-accept-all" },
                        on: {
                          click: function($event) {
                            _vm.acceptAll()
                            _vm.close()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.cookieBarAcceptAll"
                              )
                            ) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showRejectAll
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-block btn-default btn-appearance button-order-2 mb-2 mt-0",
                            attrs: { "data-testing": "cookie-bar-deny-all" },
                            on: {
                              click: function($event) {
                                _vm.denyAll()
                                _vm.close()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.cookieBarDenyAll"
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-block btn-default button-order-3 mb-2 mt-0",
                        attrs: { "data-testing": "cookie-bar-save" },
                        on: {
                          click: function($event) {
                            _vm.storeConsents()
                            _vm.close()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.cookieBarSave")
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm.isExpanded
              ? _c(
                  "div",
                  {
                    staticClass: "row py-3",
                    class: _vm.classes,
                    style: _vm.styles
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-12 mb-3" },
                      [
                        _c("privacy-settings", {
                          attrs: { "consent-groups": _vm.consentGroups }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-3" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "text-primary text-appearance d-inline-block mb-3",
                          attrs: {
                            href: "#",
                            "data-testing": "cookie-bar-hide-more-information"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.isExpanded = false
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$translate("Ceres::Template.cookieBarBack")
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-9" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-4 mt-2 mt-md-0" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-block btn-default btn-appearance",
                                attrs: {
                                  "data-testing":
                                    "cookie-bar-expanded-accept-all"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.acceptAll()
                                    _vm.close()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.cookieBarAcceptAll"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showRejectAll
                          ? _c(
                              "div",
                              { staticClass: "col-12 col-md-4 mt-2 mt-md-0" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-block btn-default btn-appearance",
                                    attrs: {
                                      "data-testing":
                                        "cookie-bar-expanded-deny-all"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.denyAll()
                                        _vm.close()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.cookieBarDenyAll"
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-md-4" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-block btn-default",
                              attrs: {
                                "data-testing": "cookie-bar-expanded-save"
                              },
                              on: {
                                click: function($event) {
                                  _vm.storeConsents()
                                  _vm.close()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.cookieBarSave"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e()
          ])
        : _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-appearance",
                attrs: {
                  "aria-label": _vm.$translate(
                    "Phywe::Template.cookieBarPrivacySettings"
                  )
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    _vm.isCollapsed = false
                  }
                }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "cookie-bar-icon",
                    attrs: {
                      width: "23",
                      height: "23",
                      viewBox: "0 0 23 23",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                      "aria-hidden": "true"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M11.5 23C9.90917 23 8.41417 22.6985 7.015 22.0955C5.61583 21.4925 4.39875 20.6742 3.36375 19.6405C2.32875 18.6067 1.50938 17.3912 0.905625 15.9938C0.301875 14.5963 0 13.1032 0 11.5144C0 10.0787 0.277917 8.67166 0.83375 7.29338C1.38958 5.91511 2.16583 4.68519 3.1625 3.60362C4.15917 2.52206 5.35708 1.65106 6.75625 0.990637C8.15542 0.330212 9.68875 0 11.3562 0C11.7587 0 12.1708 0.0191427 12.5925 0.0574282C13.0142 0.0957137 13.4454 0.162713 13.8862 0.258427C13.7137 1.11985 13.7712 1.93342 14.0588 2.69913C14.3463 3.46484 14.7775 4.10133 15.3525 4.60861C15.9275 5.1159 16.6127 5.46525 17.4081 5.65668C18.2035 5.84811 19.0229 5.80025 19.8662 5.51311C19.3679 6.64253 19.4398 7.7241 20.0819 8.7578C20.724 9.79151 21.6775 10.3275 22.9425 10.3658C22.9617 10.5764 22.976 10.7726 22.9856 10.9544C22.9952 11.1363 23 11.3325 23 11.5431C23 13.1128 22.6981 14.5916 22.0944 15.9794C21.4906 17.3673 20.6713 18.5828 19.6362 19.6261C18.6012 20.6694 17.3842 21.4925 15.985 22.0955C14.5858 22.6985 13.0908 23 11.5 23ZM9.775 9.21723C10.2542 9.21723 10.6615 9.04973 10.9969 8.71473C11.3323 8.37973 11.5 7.97295 11.5 7.49438C11.5 7.01581 11.3323 6.60903 10.9969 6.27403C10.6615 5.93903 10.2542 5.77154 9.775 5.77154C9.29583 5.77154 8.88854 5.93903 8.55312 6.27403C8.21771 6.60903 8.05 7.01581 8.05 7.49438C8.05 7.97295 8.21771 8.37973 8.55312 8.71473C8.88854 9.04973 9.29583 9.21723 9.775 9.21723ZM7.475 14.9601C7.95417 14.9601 8.36146 14.7926 8.69687 14.4576C9.03229 14.1226 9.2 13.7158 9.2 13.2372C9.2 12.7586 9.03229 12.3519 8.69687 12.0169C8.36146 11.6819 7.95417 11.5144 7.475 11.5144C6.99583 11.5144 6.58854 11.6819 6.25312 12.0169C5.91771 12.3519 5.75 12.7586 5.75 13.2372C5.75 13.7158 5.91771 14.1226 6.25312 14.4576C6.58854 14.7926 6.99583 14.9601 7.475 14.9601ZM14.95 16.1086C15.2758 16.1086 15.549 15.9985 15.7694 15.7784C15.9898 15.5583 16.1 15.2855 16.1 14.9601C16.1 14.6346 15.9898 14.3618 15.7694 14.1417C15.549 13.9216 15.2758 13.8115 14.95 13.8115C14.6242 13.8115 14.351 13.9216 14.1306 14.1417C13.9102 14.3618 13.8 14.6346 13.8 14.9601C13.8 15.2855 13.9102 15.5583 14.1306 15.7784C14.351 15.9985 14.6242 16.1086 14.95 16.1086ZM11.5 20.7029C13.8383 20.7029 15.9131 19.8989 17.7244 18.2909C19.5356 16.6829 20.5275 14.6346 20.7 12.1461C19.7417 11.7249 18.9894 11.1506 18.4431 10.4232C17.8969 9.6958 17.5279 8.88223 17.3363 7.98252C15.8604 7.77195 14.5954 7.14024 13.5413 6.08739C12.4871 5.03454 11.8354 3.77112 11.5862 2.29713C10.0529 2.25884 8.70646 2.53641 7.54688 3.12984C6.38729 3.72326 5.41937 4.48419 4.64312 5.41261C3.86687 6.34103 3.28229 7.35081 2.88937 8.44195C2.49646 9.53308 2.3 10.5572 2.3 11.5144C2.3 14.0603 3.19604 16.2283 4.98812 18.0181C6.78021 19.8079 8.95083 20.7029 11.5 20.7029Z",
                        fill: "white"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "d-none d-sm-inline-block" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Phywe::Template.cookieBarPrivacySettings")
                    )
                  )
                ])
              ]
            )
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }